import './em-heading-separator.scss';

export default {
  template: '<div class="em-heading-separator">',
};
